<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('organizations.add_user_to_team', [user ? this.getUserName(user) : ``])"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <el-radio-group class="class-radio" v-model="selectedClass"
        v-for="clazz in classes"
        :key="clazz.id"
      >
        <el-radio size="medium" :label="clazz.id">
          <span>{{clazz.name}}</span>
        </el-radio>
        <hr class="line-separate" />
      </el-radio-group>
    </template>
    <template v-slot:footer>
      <span class="dialog-footer">
        <primary-button
          :disabled="selectedClass === null"
          @click.native="handleAddToTeam"
        >
          {{ $t('organization_profile.remove_admin_modal.add') }}
        </primary-button>
        <tertiary-button @click.native="handleCancelClick">
          {{ $t('organization_profile.remove_admin_modal.no_cancel') }}
        </tertiary-button>
      </span>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import { successMessage, warningMessage } from '@/utils/messages'
  import {
    compose,
    of,
    prop,
  } from 'ramda'
  import {
      mapGetters,
      mapActions,
  } from 'vuex'

  export default {
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton
    },
    props: {
      organization: {
        type: Object,
        default: () => {}
      },
      user: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        selectedClass: null
      }
    },
    computed: {
      ...mapGetters({
        classes: 'classes/getClassList',
      }),
    },
    methods: {
      handleAddToTeam() {
        this.$emit('closed')
        this.addToGroup()
      },
      async addToGroup() {
        const students = compose(of, prop('email'))(this.user)
        try {
          await this.addUsersToClass({
            students,
            groupId: this.selectedClass,
          })
          const message = this.$i18nLabelsHelper(this.$store.getters['organization/currentOrganizationType'], 'add_to_group_success')
          this.$emit('update-learner')
          return successMessage(this.$t(message))(this)
        } catch(e) {
          const message = this.$i18nLabelsHelper(this.$store.getters['organization/currentOrganizationType'], 'add_to_group_warning')

          return warningMessage(this.$t(message))(this)
        }
      },
      handleCancelClick() {
        this.$emit('closed')
      },
      getUserName(user) {
        if (user.first_name && user.last_name) {
          return user.first_name + ' ' + user.last_name
        } else {
          return user.email;
        }
      },
      ...mapActions('classes', [
        'getClasses',
        'addUsersToClass'
      ]),
    },
    mounted() {
      try {
        this.getClasses()
      } catch {
        return warningMessage(this.$t('common.generic_error_message'))(this)
      }
    },
  }
</script>

<style lang="scss" scoped>

  p {
    margin: 0;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    color: #EB5757;
  }
  .elsa-flat-button.el-button {
    color: #546873;
    opacity: 0.7;
    &:hover {
      color: #546873;
      opacity: 0.7;
      font-weight: 700;
    }
  }
  ::v-deep .el-radio {
    .el-radio__input {
      .el-radio__inner {
        width: 18px !important;
        height: 18px !important;
      }
    }
    
    .el-radio__label {
      span {
        font-size: 18px !important;
      }
    }
  }
  .line-separate {
    width: 100%;
    border: 1px solid#E6E6E6;
    margin-top: 20px;
    opacity: 0.5;
    margin-bottom: -25px;
  }
  .class-radio {
    margin-bottom: 38px;
  }
</style>
